// ---------------------------------------------------------------------------
// AppLock — Storage backend abstraction
// ---------------------------------------------------------------------------
//
// A minimal key-value interface that abstracts the raw storage mechanism.
// Both localStorage and IndexedDB implement this interface, allowing the
// higher-level storage adapters (Passthrough / Encrypted) to be backend-
// agnostic.
//
// ---------------------------------------------------------------------------
// ---------------------------------------------------------------------------
// localStorage backend
// ---------------------------------------------------------------------------
/**
 * Wraps `localStorage` as a `StorageBackend`.
 *
 * The async interface is trivially resolved since localStorage is
 * synchronous, but this allows it to be swapped with IndexedDB
 * without any changes to the calling code.
 */
export class LocalStorageBackend {
    async getItem(key) {
        return localStorage.getItem(key);
    }
    async setItem(key, value) {
        localStorage.setItem(key, value);
    }
    async removeItem(key) {
        localStorage.removeItem(key);
    }
    async getAllKeys() {
        const keys = [];
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key !== null) {
                keys.push(key);
            }
        }
        return keys;
    }
}
//# sourceMappingURL=storage-backend.js.map